<ng-container *ngIf="_date">{{ _date | datetime:format }}</ng-container>
